import localStorageUtil from 'src/utils/localStorageUtil';
import { storageConstants } from 'src/utils/constants/storageConstants';

import memberApi from 'src/api/membershipApi';

export default function useCommon() {
  // Coming from Mobile app.
  const callPushNotification = async () => {
    const token = localStorage.getItem(storageConstants.fbToken);
    const languageCode = JSON.parse(localStorage.getItem('languageInfo') ?? '').code;

    if (token && languageCode) {
      const params = {
        option: {
          pushToken: token,
          pushLanguage: languageCode,
        },
      };

      await memberApi.callPushNotificationApi(params);
    }
  };

  // I dont know how should I migrate this fucntion from vue so I decided to migrate it into this file
  // Reference file on ANCHOR-WEBAPP: /src/plugins/common.js
  const moveIdpLogout = () => {
    const formElem = document.createElement('form');
    const signOutUrl = localStorageUtil.getIdpSignOutUrl() ?? '';
    formElem.method = 'POST';
    formElem.action = signOutUrl;
    document.body.appendChild(formElem);
    localStorageUtil.init();
    formElem.submit();
  };

  return { callPushNotification, moveIdpLogout };
}
